import styled, { createGlobalStyle } from "styled-components";

export const InputDatePickerBetweenStyled = styled.div`
  .label {
    margin-bottom: 0.5rem;
    color: ${({ theme }) => theme.COLORS.BLUE_2};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
  }
  .date_between_container {
    display: flex;
    width: 100%;
    gap: 10px;
    > .react-datepicker-wrapper {
      flex: 1 1 0;
      min-width: 0;
      display: block;
    }
    .custom_date {
      padding: 0 1rem;
      border-radius: 1rem;
      border: 0.0625rem solid ${({ theme }) => theme.COLORS.GRAY_1};
      height: 2.7rem;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: ${({ theme }) => theme.COLORS.WHITE_1};
      color: ${({ theme }) => theme.COLORS.GRAY_2};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_LIGHT};
      text-align: left;
      cursor: pointer;
      transition: border-color 0.2s ease;
      &:hover:not(:disabled) {
        border-color: ${({ theme }) => theme.COLORS.BLUE_4};
      }
      &:focus,
      &:focus-within {
        outline: none;
        border-color: ${({ theme }) => theme.COLORS.BLUE_4};
      }
      &:disabled {
        background: ${({ theme }) => theme.COLORS.GRAY_1};
        cursor: not-allowed;
      }
      .show_value {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .arrow_icon {
        margin-left: 5px;
        padding-top: 3px;
        display: flex;
        align-items: center;
      }
    }
  }

  .date_picker_container {
    display: flex;
    align-items: center;
    column-gap: 12px;
    width: fit-content;
  }

  .react-datepicker-wrapper {
    width: 100%;
    display: block;
  }

  .theme_standard {
    .date_between_container {
      width: fit-content;
      > .react-datepicker-wrapper {
        flex: 0 0 auto;
      }
    }
    .custom_date {
      flex-shrink: 0;
      padding: 10px 10px;
      border-radius: 8px;
      width: auto;
    }
  }
`;

export const InputDatePickerBetweenPopupStyle = createGlobalStyle`
  .ipdb_dp_popper {
    z-index: 5;

    .react-datepicker {
      border: none;
      border-radius: 12px;
      box-shadow: 0 8px 24px rgba(16, 24, 40, 0.12);
      background: ${({ theme }) => theme.COLORS.WHITE_1};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
      color: ${({ theme }) => theme.COLORS.BLUE_2};
      padding: 8px;
    }

    .react-datepicker__triangle {
      display: none;
    }

    .react-datepicker__header {
      background: transparent;
      border-bottom: none;
      padding: 0;
    }

    .react-datepicker__current-month,
    .react-datepicker-year-header {
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
      font-size: ${({ theme }) => theme.FONT.SIZE.S15};
      color: ${({ theme }) => theme.COLORS.BLUE_2};
      padding: 6px 0 10px;
    }

    .react-datepicker__day-names {
      margin-top: 4px;
      display: flex;
      justify-content: space-around;
    }

    .react-datepicker__day-name {
      color: ${({ theme }) => theme.COLORS.GRAY_2};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
      width: 2rem;
      line-height: 2rem;
      margin: 0.18rem;
    }

    .react-datepicker__month {
      margin: 0.4rem 0 0;
    }

    .react-datepicker__week {
      display: flex;
      justify-content: space-around;
    }

    .react-datepicker__day {
      width: 2rem;
      line-height: 2rem;
      margin: 0.18rem;
      border-radius: 50%;
      color: ${({ theme }) => theme.COLORS.BLUE_2};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      transition:
        background 0.15s ease,
        color 0.15s ease;
    }

    .react-datepicker__day:hover {
      background: ${({ theme }) => theme.COLORS.BLUE_5};
      color: ${({ theme }) => theme.COLORS.BLUE_4};
      border-radius: 50%;
    }

    .react-datepicker__day--today {
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
      color: ${({ theme }) => theme.COLORS.BLUE_4};
      box-shadow: inset 0 0 0 1px ${({ theme }) => theme.COLORS.BLUE_4};
    }

    .react-datepicker__day--keyboard-selected {
      background: ${({ theme }) => theme.COLORS.BLUE_5};
      color: ${({ theme }) => theme.COLORS.BLUE_4};
    }

    .react-datepicker__day--selected,
    .react-datepicker__day--in-range,
    .react-datepicker__day--in-selecting-range {
      background: ${({ theme }) => theme.COLORS.BLUE_4};
      color: ${({ theme }) => theme.COLORS.WHITE_1};
      box-shadow: none;
    }

    .react-datepicker__day--selected:hover,
    .react-datepicker__day--in-range:hover {
      background: ${({ theme }) => theme.COLORS.BLUE_3};
      color: ${({ theme }) => theme.COLORS.WHITE_1};
    }

    .react-datepicker__day--outside-month {
      color: ${({ theme }) => theme.COLORS.GRAY_11};
    }

    .react-datepicker__day--disabled {
      color: ${({ theme }) => theme.COLORS.GRAY_11};
      cursor: not-allowed;
    }

    .dp_header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 4px 12px;
      gap: 8px;
    }

    .dp_selects {
      display: flex;
      gap: 8px;
      flex: 1;
      justify-content: center;
    }

    .dp_cs {
      position: relative;
      display: inline-block;
    }

    .dp_cs_btn {
      display: inline-flex;
      align-items: center;
      justify-content: space-between;
      gap: 4px;
      height: 36px;
      padding: 6px 6px 6px 12px;
      border-radius: 8px;
      border: 1px solid ${({ theme }) => theme.COLORS.GRAY_1};
      background: ${({ theme }) => theme.COLORS.WHITE_1};
      color: ${({ theme }) => theme.COLORS.BLUE_2};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      cursor: pointer;
      transition:
        border-color 0.2s ease,
        box-shadow 0.2s ease;
    }

    .dp_cs_btn:hover {
      border-color: ${({ theme }) => theme.COLORS.BLUE_4};
    }

    .dp_cs_btn:focus {
      outline: none;
      border-color: ${({ theme }) => theme.COLORS.BLUE_4};
      box-shadow: 0 0 0 3px rgba(33, 111, 237, 0.12);
    }

    .dp_cs_label {
      flex: 1;
      text-align: left;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .dp_cs_month .dp_cs_btn {
      min-width: 120px;
    }

    .dp_cs_year .dp_cs_btn {
      min-width: 90px;
    }

    .dp_cs_menu {
      position: absolute;
      top: calc(100% + 4px);
      left: 0;
      right: 0;
      z-index: 10;
      max-height: 220px;
      overflow-y: auto;
      margin: 0;
      padding: 4px 0;
      list-style: none;
      background: ${({ theme }) => theme.COLORS.WHITE_1};
      border: 1px solid ${({ theme }) => theme.COLORS.GRAY_1};
      border-radius: 8px;
      box-shadow: 0 4px 16px rgba(16, 24, 40, 0.1);
    }

    .dp_cs_menu::-webkit-scrollbar {
      width: 6px;
    }

    .dp_cs_menu::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.COLORS.GRAY_11};
      border-radius: 3px;
    }

    .dp_cs_menu::-webkit-scrollbar-track {
      background: transparent;
    }

    .dp_cs_item {
      padding: 8px 12px;
      color: ${({ theme }) => theme.COLORS.BLUE_2};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      cursor: pointer;
      white-space: nowrap;
      transition:
        background 0.15s ease,
        color 0.15s ease;
    }

    .dp_cs_item:hover {
      background: ${({ theme }) => theme.COLORS.BLUE_5};
      color: ${({ theme }) => theme.COLORS.BLUE_4};
    }

    .dp_cs_item.active {
      background: ${({ theme }) => theme.COLORS.BLUE_4};
      color: ${({ theme }) => theme.COLORS.WHITE_1};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
    }

    .dp_nav_btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
      border-radius: 8px;
      border: none;
      background: transparent;
      color: ${({ theme }) => theme.COLORS.BLUE_2};
      cursor: pointer;
      transition:
        background 0.15s ease,
        color 0.15s ease;
    }

    .dp_nav_btn:hover:not(:disabled) {
      background: ${({ theme }) => theme.COLORS.BLUE_5};
      color: ${({ theme }) => theme.COLORS.BLUE_4};
    }

    .dp_nav_btn:disabled {
      opacity: 0.35;
      cursor: not-allowed;
    }

    .react-datepicker__month-wrapper {
      display: flex;
      justify-content: space-between;
      margin: 4px 0;
    }

    .react-datepicker__month-text,
    .react-datepicker__quarter-text,
    .react-datepicker__year-text {
      padding: 8px 10px;
      border-radius: 8px;
      color: ${({ theme }) => theme.COLORS.BLUE_2};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      transition:
        background 0.15s ease,
        color 0.15s ease;
    }

    .react-datepicker__month-text:hover,
    .react-datepicker__quarter-text:hover,
    .react-datepicker__year-text:hover {
      background: ${({ theme }) => theme.COLORS.BLUE_5};
      color: ${({ theme }) => theme.COLORS.BLUE_4};
    }

    .react-datepicker__month-text--selected,
    .react-datepicker__month-text--keyboard-selected,
    .react-datepicker__year-text--selected,
    .react-datepicker__year-text--keyboard-selected,
    .react-datepicker__quarter-text--selected,
    .react-datepicker__quarter-text--keyboard-selected {
      background: ${({ theme }) => theme.COLORS.BLUE_4};
      color: ${({ theme }) => theme.COLORS.WHITE_1};
    }

    .react-datepicker__navigation {
      top: 14px;
    }

    .react-datepicker__navigation-icon::before {
      border-color: ${({ theme }) => theme.COLORS.BLUE_2};
      border-width: 2px 2px 0 0;
      height: 8px;
      width: 8px;
    }

    .react-datepicker__navigation:hover *::before {
      border-color: ${({ theme }) => theme.COLORS.BLUE_4};
    }
  }
`;
